import { render } from "./BrandSportAktiv.vue?vue&type=template&id=1fe2134b"
import script from "./BrandSportAktiv.vue?vue&type=script&lang=ts"
export * from "./BrandSportAktiv.vue?vue&type=script&lang=ts"

import "./BrandSportAktiv.vue?vue&type=style&index=0&id=1fe2134b&lang=scss"
script.render = render

export default script